import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { HttpStatus } from 'src/util/http/statusCodes';

const defaultMessages = {
  [HttpStatus.BAD_REQUEST]: "Requisição inválida",
  [HttpStatus.UNAUTHORIZED]: "Seu acesso está proibido para esses dados",
  [HttpStatus.FORBIDDEN]: "Você não possui acesso aos dados solicitados",
  [HttpStatus.NOT_FOUND]: "Estes dados não existem",
  [HttpStatus.UNPROCESSABLE_ENTITY]: "Erro de validação nos dados enviados",
  [HttpStatus.INTERNAL_SERVER_ERROR]: "Problema de acesso ao servidor. Por favor, contacte o suporte",
};

const defaultErrorMessage = "Ocorreu um erro inesperado. Por favor, contacte o suporte";
const defaultSuccessMessage = "Operação realizada com sucesso";

export default function useErrorToast() {

  const [errorData, setErrorData] = useState({ error: null, message: null });

  // Mostra erro vindo de objeto (ex: resposta do axios)
  const showErrorObj = useCallback((err, msg) => {
    const status = err?.response?.status;
    const fallbackMsg = defaultMessages[status] || defaultErrorMessage;
    toast.error(msg || fallbackMsg);
  }, []);

  // Mostra erro vindo de string
  const showErrorString = useCallback((err) => {
    toast.error(err || defaultErrorMessage);
  }, []);

  // Checa se há erro e armazena no state
  const checkError = useCallback((err, msg = null) => {
    if (!err) return false;
    setErrorData({ error: err, message: msg });
    return true;
  }, []);

  // Mostra erro sempre que o state mudar
  useEffect(() => {
    if (!errorData.error) return;
    if (typeof errorData.error === 'object') {
      showErrorObj(errorData.error, errorData.message);
    } else {
      showErrorString(errorData.error);
    }
    setErrorData({ error: null, message: null });
  }, [errorData, showErrorObj, showErrorString]);

  // Mostra toast de sucesso apenas se NÃO houve erro
  const confirmSuccess = useCallback((msg) => {
    if (!errorData.error) {
      toast.success(msg || defaultSuccessMessage);
    }
  }, [errorData.error]);

  return [checkError, confirmSuccess];
}